// removed by extract-text-webpack-plugin
module.exports = {"header":"_3bMN686qBPYP1df9uC_kfN","container":"izfMlpocQzlhdzhHXlcLP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = 916
// module chunks = 0